/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coins_Pack_CartInputs */

const en_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cart of Coins`)
};

const ar_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عربة عملات`)
};

const de_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Wagenfüllung Münzen`)
};

const es_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrito de monedas`)
};

const fr_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un wagon de Pièces`)
};

const it_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carriola di Monete`)
};

const ja_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カート一杯のコイン`)
};

const ko_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 한 수레`)
};

const pt_br_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrinho de moedas`)
};

const ru_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тележка монет`)
};

const th_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญหนึ่งรถเข็น`)
};

const tr_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir El Arabası Jeton`)
};

const zh_cn_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一推车金币`)
};

const zh_tw_coins_pack_cart = /** @type {(inputs: Coins_Pack_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一推車金幣`)
};

/**
* | output |
* | --- |
* | "Cart of Coins" |
*
* @param {Coins_Pack_CartInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const coins_pack_cart = /** @type {((inputs?: Coins_Pack_CartInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_Pack_CartInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coins_pack_cart(inputs)
	if (locale === "ar") return ar_coins_pack_cart(inputs)
	if (locale === "de") return de_coins_pack_cart(inputs)
	if (locale === "es") return es_coins_pack_cart(inputs)
	if (locale === "fr") return fr_coins_pack_cart(inputs)
	if (locale === "it") return it_coins_pack_cart(inputs)
	if (locale === "ja") return ja_coins_pack_cart(inputs)
	if (locale === "ko") return ko_coins_pack_cart(inputs)
	if (locale === "pt_br") return pt_br_coins_pack_cart(inputs)
	if (locale === "ru") return ru_coins_pack_cart(inputs)
	if (locale === "th") return th_coins_pack_cart(inputs)
	if (locale === "tr") return tr_coins_pack_cart(inputs)
	if (locale === "zh_cn") return zh_cn_coins_pack_cart(inputs)
	return zh_tw_coins_pack_cart(inputs)
});